import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './Navbar.css';
import logo from '../assets/hilal-makine.png';

function NavigationBar() {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 20) {   // 50px scroll sonrası arkaplan aktif
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = -100;
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <Navbar expand="lg" fixed="top" className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}>
      <Container>
        <Navbar.Brand onClick={() => scrollToSection('hero')} className="navbar-brand-text">
          <img src={logo} alt="Hilal Makine" className="navbar-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link onClick={() => scrollToSection('info')}>Hakkımızda</Nav.Link>
            <Nav.Link onClick={() => scrollToSection('gallery')}>Galeri</Nav.Link>           
            <Nav.Link onClick={() => scrollToSection('machines')}>Makinelerimiz</Nav.Link>
            <Nav.Link onClick={() => scrollToSection('projects')}>Faaliyetlerimiz</Nav.Link> 
            <Nav.Link onClick={() => scrollToSection('references')}>Referanslar</Nav.Link> 
            <Nav.Link onClick={() => scrollToSection('contact')}>İletişim</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
